module.exports = __webpack_public_path__ + "static/media/SadEmoji.67b37bc1.png";